<template>
  <page>
    <form>
      <v-container fluid grid-list-md>
        <v-layout row wrap>
          <v-flex xs12 sm12 md12 lg12>
            <v-expansion-panels v-model="panel1" multiple>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <div><v-icon>mdi-filter-variant</v-icon> {{ label.selectionCriteria }}</div>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="ePanelHeaderColor">
                  <v-card>
                    <v-card-text>
                      <v-container fluid grid-list-sm>
                        <v-layout row wrap>
                          <v-flex xs12 sm6 md6 lg6>
                            <cal-picker
                              v-model="form.frTranDate"
                              :label="label.frTranDate"
                              :data-vv-as="label.frTranDate"
                              data-vv-name="form.frTranDate"
                              :error-messages="errors.collect('form.frTranDate')"
                              v-validate="'required'"
                            />
                          </v-flex>

                          <v-flex xs12 sm6 md6 lg6>
                            <cal-picker
                              v-model="form.toTranDate"
                              :label="label.toTranDate"
                              :data-vv-as="label.toTranDate"
                              data-vv-name="form.toTranDate"
                              :error-messages="errors.collect('form.toTranDate')"
                              v-validate="'required|from_to_date:' + form.frTranDate"
                            />
                          </v-flex>

                          <v-flex xs12 sm6 md6 lg6>
                            <cal-picker
                              v-model="form.crDrNoteTranDate"
                              :label="label.crDrNoteTranDate"
                              :data-vv-as="label.crDrNoteTranDate"
                              data-vv-name="form.crDrNoteTranDate"
                              :error-messages="errors.collect('form.crDrNoteTranDate')"
                              v-validate="'required'"
                            />
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card-text>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-flex>
          <v-spacer class="mt-2"></v-spacer>
          <v-flex xs12 sm12 md12 lg12>
            <v-expansion-panels v-model="panel2" multiple>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <div><v-icon>mdi-filter-variant</v-icon> {{ label.filter }}</div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-card>
                    <v-card-text>
                      <v-container fluid grid-list-sm>
                        <v-layout row wrap>
                          <v-flex xs12 md6>
                            <v-text-field
                              v-model="form.branch"
                              :label="label.branch"
                              :error-messages="errors.collect('branch')"
                              data-vv-name="branch"
                              :data-vv-as="label.branch"
                              append-icon="mdi-magnify"
                              readonly
                              @click:append="multibranchlist = true"
                            ></v-text-field>
                          </v-flex>

                          <v-flex xs12 md6></v-flex>

                          <v-flex xs12 md6>
                            <v-text-field
                              v-model="form.dept"
                              :label="label.dept"
                              :error-messages="errors.collect('dept')"
                              data-vv-name="dept"
                              :data-vv-as="label.dept"
                              append-icon="mdi-magnify"
                              readonly
                              @click:append="multideptlist = true"
                            ></v-text-field>
                          </v-flex>

                          <v-flex xs12 md6></v-flex>
                        </v-layout>
                      </v-container>
                    </v-card-text>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-flex>
        </v-layout>
      </v-container>
      <v-spacer class="mt-2"></v-spacer>
      <v-container fluid grid-list-sm>
        <v-layout row wrap>
          <v-flex lg12 xs12>
            <v-checkbox
              dense
              v-model="form.printRptRunTime"
              :label="label.printRptRunTime"
              data-vv-name="printRptRunTime"
              :data-vv-as="label.printRptRunTime"
            ></v-checkbox>
          </v-flex>
          <v-flex lg6 xs12>
            <v-btn class="mr-2" color="primary" type="submit" :loading="loading" @click.prevent="doExport">
              <v-icon left dark>mdi-file-export</v-icon>
              {{ label.export }}
            </v-btn>
            <v-btn-toggle dense mandatory v-model="form.format">
              <v-btn text v-for="format in supportedList" :key="format.value" :value="format.value">
                <span>{{ format.label }}</span>
                <v-icon :color="format.color">{{ format.icon }}</v-icon>
              </v-btn>
            </v-btn-toggle>
          </v-flex>
        </v-layout>
      </v-container>
      <v-dialog v-model="multibranchlist" width="900px" persistent>
        <multi-branch-help-list :brn="form.branch" @close="doClose" @doAssign="doAssignBranch($event)"></multi-branch-help-list>
      </v-dialog>
      <v-dialog v-model="multideptlist" width="900px" persistent>
        <multi-dept-help-list :dept="form.dept" @close="doClose" @doAssign="doAssignDepartment($event)"></multi-dept-help-list>
      </v-dialog>
    </form>
  </page>
</template>

<script>
import MultiBranchHelpList from '@/components/core/common/dialog/MultiBranchHelpList.vue'
import MultiDeptHelpList from '@/components/core/common/dialog/MultiDeptHelpList.vue'
import MessageMixin from '@/mixins/message'
import { extractMenu } from '@/utils/extract'
import { reportFormat } from '@/const/report'
export default {
  data() {
    return {
      form: {
        frTranDate: null,
        toTranDate: null,
        crDrNoteTranDate: null,
        branch: 'All',
        dept: 'All',
        format: 'PDF',
        printRptRunTime: true
      },
      label: {
        frTranDate: 'Facultative Reinsurance Bordereau For Policies From Transaction Date*',
        toTranDate: 'Facultative Reinsurance Bordereau For Policies To Transaction Date*',
        crDrNoteTranDate: 'Credit/Debit Notes Generated Transaction Date*',
        branch: 'Branch(es)',
        dept: 'Department(s)',
        format: undefined,
        printRptRunTime: 'Print Runtime Parameters',
        selectionCriteria: 'Selection Criteria',
        filter: 'Filters',
        export: 'Submit'
      },
      multibranchlist: false,
      multideptlist: false,
      supportedFormat: [],
      loading: false,
      menu: [],
      panel1: [0],
      panel2: [0]
    }
  },
  beforeMount() {
    if (this.$store.state.underwriting.specialFuncUWSettings.init !== 1) {
      this.$store.dispatch('specialFuncUWInit').then(() => {
        this.doInit()
      })
    } else {
      this.doInit()
    }
  },
  methods: {
    async doAssignBranch(Obj) {
      this.form.branch = []
      this.form.branch = Obj.finalSelectedItems.toString()
    },
    async doAssignDepartment(Obj) {
      this.form.dept = []
      this.form.dept = Obj.finalSelectedItems.toString()
    },
    doClose() {
      this.multibranchlist = false
      this.multideptlist = false
    },
    doExport() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.processExport()
        }
      })
    },
    async doInit() {
      try {
        const apiURI = this.fnMenu.facultativeReisuranceBordereau
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result.data
          if (data) {
            this.supportedFormat = data.format
            this.menu = extractMenu(result.data._links)
          }
        }
      } catch (err) {
        throw err
      }
    },
    async processExport() {
      const apiURI = this.menu.processBatchFacRIBordereaux
      if (apiURI) {
        try {
          this.loading = true
          await this.$http.post(apiURI, this.form)
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    }
  },
  computed: {
    fnMenu() {
      return this.$store.state.underwriting.specialFuncUWSettings.menu
    },
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map((format) => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    }
  },
  created() {},
  mixins: [MessageMixin],
  components: { MultiBranchHelpList, MultiDeptHelpList }
}
</script>
